/**
 * Quotes API.
 */

import { apiFetch } from './fetch';
import { API } from '../constants';
import type { Quote, QuoteLineItem } from '../types/dvms.types';

export async function listQuotes(projectId?: string): Promise<Quote[]> {
    const query = projectId ? `${API.QUOTES}?projectId=${encodeURIComponent(projectId)}` : API.QUOTES;
    const result = await apiFetch<Quote[] | null>(query);
    return Array.isArray(result) ? result : [];
}

export async function countQuotesByProject(projectId: string): Promise<number> {
    const resp = await apiFetch<{ count: number }>(`${API.QUOTES}/count?projectId=${encodeURIComponent(projectId)}`);
    return resp.count;
}

export async function createQuote(payload: Omit<Quote, 'id' | 'createdAt' | 'createdBy' | 'isActive'>): Promise<Quote> {
    return apiFetch<Quote>(API.QUOTES, {
        method: 'POST',
        body: JSON.stringify(payload),
    });
}

export async function updateQuoteLineItems(quoteId: string, lineItems: QuoteLineItem[]): Promise<void> {
    await apiFetch(`${API.QUOTES}/${quoteId}/line-items`, {
        method: 'PUT',
        body: JSON.stringify(lineItems),
    });
}
